(function (Translator) {
    // es
    Translator.add("administration.user_search_button", "Buscar", "EvpAdministrationBundle", "es");
    Translator.add("administration.user_search_label", "ID del usuario", "EvpAdministrationBundle", "es");
    Translator.add("forbidden", "No se permite", "EvpAdministrationBundle", "es");
    Translator.add("internal_server_error", "El error del servidor", "EvpAdministrationBundle", "es");
    Translator.add("invalid_code", "C\u00f3digo no v\u00e1lido", "EvpAdministrationBundle", "es");
    Translator.add("invalid_grant", "Acceso denegado", "EvpAdministrationBundle", "es");
    Translator.add("invalid_parameters", "Par\u00e1metros incorrectos", "EvpAdministrationBundle", "es");
    Translator.add("invalid_request", "Consulta no v\u00e1lida", "EvpAdministrationBundle", "es");
    Translator.add("invalid_state", "Estado no v\u00e1lido", "EvpAdministrationBundle", "es");
    Translator.add("limits_exceeded", "El l\u00edmite alcanzado", "EvpAdministrationBundle", "es");
    Translator.add("logout", "Salir", "EvpAdministrationBundle", "es");
    Translator.add("not_acceptable", "No se aceptan", "EvpAdministrationBundle", "es");
    Translator.add("not_found", "No encontrado", "EvpAdministrationBundle", "es");
    Translator.add("pagination.first", "Primero", "EvpAdministrationBundle", "es");
    Translator.add("pagination.last", "\u00daltimo", "EvpAdministrationBundle", "es");
    Translator.add("pagination.next", "Adelante", "EvpAdministrationBundle", "es");
    Translator.add("pagination.page_out_of", "De", "EvpAdministrationBundle", "es");
    Translator.add("pagination.previous", "Atr\u00e1s ", "EvpAdministrationBundle", "es");
    Translator.add("rate_limit_exceeded", "El l\u00edmite alcanzado", "EvpAdministrationBundle", "es");
    Translator.add("unauthorized", "Acceso denegado", "EvpAdministrationBundle", "es");
})(Translator);
